import { Component } from '@mycolorway/tao';
import request, { clearCache } from 'next/javascripts/modules/request';
import getLoadingElement from 'next/javascripts/modules/page-loading';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/projects/kanban/todolist-comment-action.scss';

Component('tr-project-kanban-todolist-comment-action', {
  mixins: [eventListenerMixin],

  properties: {
    url: String,
  },

  connected() {
    this.slide = this.querySelector('tr-slide');

    this.listenTo(this, 'click', this.showCommentSlide.bind(this));
    this.listenTo(document, 'click', (event) => {
      if (this.contains(event.target)) return;

      if (this.slide.isOpen()
        && closest(event.target, '.header, tr-fullscreen-page')) {
        this.slide.close();
      }
    });
  },

  ready() {
    document.body.appendChild(this.slide);
  },

  beforeCache() {
    if (this.slide && !this.contains(this.slide)) {
      this.appendChild(this.slide);
    }
  },

  showCommentSlide() {
    this.slide.setContent(getLoadingElement('').outerHTML);
    this.slide.open();

    if (this.request) this.request.abort();
    this.request = request({
      url: this.url,
      dataType: 'script',
    });
  },

  disconnected() {
    this.stopListening();

    if (this.request) this.request.abort();
    if (this.slide) this.slide.parentNode.removeChild(this.slide);

    clearCache();
  },
});
